export const InvoiceType = {
  FIAT: 'FIAT',
  CRYPTO: 'CRYPTO',
} as const;

export type InvoiceType = (typeof InvoiceType)[keyof typeof InvoiceType];

export const InvoiceStatus = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
} as const;

export type InvoiceStatus = (typeof InvoiceStatus)[keyof typeof InvoiceStatus];

export const PaymentStatus = {
  PENDING: 'PENDING',
  PARTIAL: 'PARTIAL',
  COMPLETED: 'COMPLETED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
} as const;

export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];

export const PaymentConfirmationState = {
  DETECTED: 'DETECTED',
  CONFIRMING: 'CONFIRMING',
  CONFIRMED: 'CONFIRMED',
} as const;

export type PaymentConfirmationState =
  (typeof PaymentConfirmationState)[keyof typeof PaymentConfirmationState];

export type PaymentConfirmation = {
  state: PaymentConfirmationState;
  network: string;
  asset: string;
  amount: string;
  txHash: string;
  confirmations: number;
  requiredConfirmations: number;
  detectedAt: string;
  confirmedAt?: string | null;
};

export type Invoice = {
  id: string;
  customerFirstName?: string | null;
  customerLastName?: string | null;
  invoiceCreatorFirstName?: string | null;
  invoiceCreatorLastName?: string | null;
  merchantLogoUrl?: string | null;
  merchantLegalName?: string | null;
  billingAddressLine?: string | null;
  billingCity?: string | null;
  billingPostalCode?: string | null;
  billingCountry?: string | null;
  taxId?: string | null;
  companyRegistrationNumber?: string | null;
  referenceId: string;
  description?: string | null;
  totalAmount: string;
  currency: string;
  amount: string;
  paidAmount: string;
  acceptedPaymentAssets?: string[];
  remainingAmount: string;
  remainingAmountWithFee: string;
  platformFeeAmount?: string | null;
  invoiceType: InvoiceType;
  status: InvoiceStatus;
  paymentStatus?: PaymentStatus | null;
  paymentExpiredAt?: string | null;
  paymentConfirmation?: PaymentConfirmation | null;
};

export const InvoiceStreamEventType = {
  SNAPSHOT: 'invoice_snapshot',
  UPDATED: 'invoice_updated',
  PAYMENT_DETECTED: 'payment_detected',
  PAYMENT_CONFIRMING: 'payment_confirming',
  PAYMENT_PARTIAL: 'payment_partial',
  PAID: 'invoice_paid',
  PAYMENT_EXPIRED: 'payment_expired',
} as const;

export type InvoiceStreamEventType =
  (typeof InvoiceStreamEventType)[keyof typeof InvoiceStreamEventType];

export type InvoiceStreamEventData = {
  invoice: Invoice;
  updatedAt: string;
};

export type InvoicePaymentHistoryItem = {
  date: string;
  asset: string;
  amount: string;
  txId: string;
};

export type InvoicePaymentHistoryResponse = {
  data: InvoicePaymentHistoryItem[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
};
